
import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import { FilterableMasterSelectableMixin, StandardOption } from "../../../system/selectors/mixins";
import { DomainRegistry } from "../../../../domain";
import { User } from "../../../../domain/user";

@Component({
})
export default class UserSelectableMixin extends Mixins(FilterableMasterSelectableMixin) {
  values: User[];

  created() {
    const repository = DomainRegistry.user.getUserRepository();
    repository.getAllEntities()
      .then(e => this.values = e)
      .catch(e => {
        this.$error(
          "職員情報取得失敗",
          "職員情報を取得できませんでした。",
          e,
        );
      });
  }

  get displayOptions(): StandardOption<User>[] {
    if (!this.$configuration.behavior.user.finder.shouldShowPhoneNumber) {
      return this.options;
    }
    return Enumerable.from(this.values)
      .select(v => new StandardOption<User>(v.nameAndPhoneNumber, v))
      .toArray();
  }
}
